import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  projectId: 'devpilot-85b7a',
  appId: '1:80287646105:web:adb067f9d4ee4873dd1308',
  storageBucket: 'devpilot-85b7a.firebasestorage.app',
  apiKey: 'AIzaSyAJ8TfUNa3NLivRMhqRu-LBco2iQwllXqY',
  authDomain: 'devpilot-85b7a.firebaseapp.com',
  messagingSenderId: '80287646105',
  measurementId: 'G-BSXW70MGW9',
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: 'select_account' });
